import { toast } from "react-toastify";
import { fetchWrapper } from "src/services/http_requests";
import { paramsUrl } from "src/utils/halper";
import { 
    HOUSEHOLD_RESILIENCE_LIST_FAIL, 
    HOUSEHOLD_RESILIENCE_LIST_REQUEST, 
    HOUSEHOLD_RESILIENCE_LIST_SUCCESS,
    HOUSEHOLD_RESILIENCE_CREATE_FAIL,
    HOUSEHOLD_RESILIENCE_CREATE_REQUEST,
    HOUSEHOLD_RESILIENCE_CREATE_SUCCESS,
    HOUSEHOLD_RESILIENCE_UPDATE_FAIL,
    HOUSEHOLD_RESILIENCE_UPDATE_REQUEST,
    HOUSEHOLD_RESILIENCE_UPDATE_SUCCESS,
    HOUSEHOLD_RESILIENCE_DELETE_FAIL,
    HOUSEHOLD_RESILIENCE_DELETE_REQUEST,
    HOUSEHOLD_RESILIENCE_DELETE_SUCCESS
} from "../Conistance/HouseholdResilienceConistance"

const BASE_URL = process.env.REACT_APP_API_URL

export const householdResilienceListAction = (filter) => async (dispatch) => {
    dispatch({ type: HOUSEHOLD_RESILIENCE_LIST_REQUEST });
    try {
        // Adjust the endpoint as needed for household resilience data
        const data = await fetchWrapper.get(`${BASE_URL}/finance_resilience_mapping/list${paramsUrl(filter)}`);
        dispatch({ type: HOUSEHOLD_RESILIENCE_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: HOUSEHOLD_RESILIENCE_LIST_FAIL, payload: error })
        toast.error(error)
    }
}

export const householdResilienceCreateAction = (resilienceData, refetchDataList) => async (dispatch) => {
    dispatch({ type: HOUSEHOLD_RESILIENCE_CREATE_REQUEST })
    try {
        const data = await fetchWrapper.post(`${BASE_URL}/household_resilience/create`, JSON.stringify(resilienceData))
        dispatch({ type: HOUSEHOLD_RESILIENCE_CREATE_SUCCESS, payload: data })
        toast.success(data?.message);
        if (data?.success) {
            setTimeout(() => {
                refetchDataList && refetchDataList();
            }, 600);
        }
    } catch (error) {
        dispatch({ type: HOUSEHOLD_RESILIENCE_CREATE_FAIL, payload: error })
        toast.error(error)
    }
}

export const householdResilienceUpdateAction = (resilienceId, resilienceData, refetchDataList) => async (dispatch) => {
    dispatch({ type: HOUSEHOLD_RESILIENCE_UPDATE_REQUEST })
    try {
        const data = await fetchWrapper.put(`${BASE_URL}/household_resilience/update/${resilienceId}`, JSON.stringify(resilienceData))
        dispatch({ type: HOUSEHOLD_RESILIENCE_UPDATE_SUCCESS, payload: data })
        toast.success(data?.message);
        if (data?.success) {
            setTimeout(() => {
                refetchDataList && refetchDataList();
            }, 600);
        }
    } catch (error) {
        dispatch({ type: HOUSEHOLD_RESILIENCE_UPDATE_FAIL, payload: error })
        toast.error(error)
    }
}

export const householdResilienceDeleteAction = (resilienceId, refetchDataList) => async (dispatch) => {
    dispatch({ type: HOUSEHOLD_RESILIENCE_DELETE_REQUEST })
    try {
        const data = await fetchWrapper.put(`${BASE_URL}/household_resilience/delete/${resilienceId}`)
        dispatch({ type: HOUSEHOLD_RESILIENCE_DELETE_SUCCESS, payload: data })
        toast.success(data?.message);
        if (data?.success) {
            setTimeout(() => {
                refetchDataList && refetchDataList();
            }, 600);
        }
    } catch (error) {
        dispatch({ type: HOUSEHOLD_RESILIENCE_DELETE_FAIL, payload: error })
        toast.error(error)
    }
} 